export default function HTTP404({ marketplace, account }) {
    return (
        <main style={{ padding: "1rem 0" }}>
        <h2>404</h2>
      </main>
    );
}